import { makeStyles } from '@material-ui/core/styles';

// Mirrors the staff quote form's layout (quote/components/quote-forms): a 720px centered
// column of collapsible section cards with beige_25 bodies on the beige page background.
const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: 720,
    margin: '0 auto',
    position: 'relative',
    padding: theme.spacing(8, 0)
  },
  title: {
    justifyContent: 'center',
    marginBottom: theme.spacing(1)
  },
  subtitle: {
    justifyContent: 'center',
    marginBottom: theme.spacing(8)
  },
  // Same as the quote form's Collapsible cardBody (quote/components/collapsible).
  cardBody: {
    background: theme.colorPalette.beige_25,
    width: '100%',
    margin: 0,
    padding: 24,
    borderRadius: '0 0 6px 6px'
  },
  paymentMethodRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 0),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  defaultBadge: {
    marginLeft: theme.spacing(2),
    color: theme.colorPalette.green_75,
    fontWeight: 600
  },
  actions: {
    marginTop: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2)
  },
  // Same as the quote form's submit (quote-forms.styles.js).
  submitButton: {
    width: 260,
    fontWeight: 600,
    fontSize: 16
  },
  rowActions: {
    display: 'flex',
    gap: theme.spacing(2)
  },
  // The quote form gets section stacking from its fieldset's flex gap; same here for the
  // sections inside one <Form>.
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  error: {
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    color: theme.colors.error
  }
}));

export default useStyles;
